<template>
	<div class="wrapper referral-page">
		<!-- Header -->
		<Header />
		<!-- HeaderMenu -->
		<HeaderMenu />

		<div class="contents">
			<div class="layout">
				<div class="left">
					<div class="pc-only">
						<Sidebar />
					</div>
				</div>
				<div class="right">
					<h1>{{ $t("REFERRAL") }}</h1>
					<div class="tab-area">
						<div
							class="tab link-over"
							v-on:click="isSelect('1')"
							v-bind:class="{ active: isActive === '1' }"
						>
							{{ $t("Left referral") }}
						</div>
						<div
							class="tab link-over"
							v-on:click="isSelect('2')"
							v-bind:class="{ active: isActive === '2' }"
						>
							{{ $t("Right referral") }}
						</div>
					</div>
					<div class="tab-contents" v-show="isActive === '1'">
						<div class="copy-area">
							<h2>{{ $t("REFERRAL CODE") }}</h2>
							<div class="input-area">
								<input
									type="text"
									id="code"
									value="jfoweajfiojfafa"
									v-model="code"
									readonly
								/>
								<span
									class="copy-btn"
									v-clipboard:copy="code"
									v-clipboard:success="codeCopy"
									v-clipboard:error="codeError"
									>COPY</span
								>
							</div>
						</div>
						<div class="copy-area">
							<h2>{{ $t("REFERRAL URL") }}</h2>
							<div class="input-area">
								<input
									type="text"
									id="url"
									value="https://www.OOO.com/jfoweajfioj…"
									v-model="url"
									readonly
								/>
								<span
									class="copy-btn"
									v-clipboard:copy="url"
									v-clipboard:success="urlCopy"
									v-clipboard:error="urlError"
									>COPY</span
								>
							</div>
						</div>
					</div>
					<div class="tab-contents" v-show="isActive === '2'">
						<div class="copy-area">
							<h2>{{ $t("REFERRAL CODE") }}</h2>
							<div class="input-area">
								<input
									type="text"
									id="code"
									value="jfoweajfiojfafa"
									v-model="code"
									readonly
								/>
								<span
									class="copy-btn"
									v-clipboard:copy="code"
									v-clipboard:success="codeCopy"
									v-clipboard:error="codeError"
									>COPY</span
								>
							</div>
						</div>
						<div class="copy-area">
							<h2>{{ $t("REFERRAL URL") }}</h2>
							<div class="input-area">
								<input
									type="text"
									id="url"
									value="https://www.OOO.com/jfoweajfioj…"
									v-model="url"
									readonly
								/>
								<span
									class="copy-btn"
									v-clipboard:copy="url"
									v-clipboard:success="urlCopy"
									v-clipboard:error="urlError"
									>COPY</span
								>
							</div>
						</div>
					</div>
					<div class="table">
						<h2>{{ $t("Referral history") }}</h2>
						<table>
							<tr>
								<th>{{ $t("Date") }}</th>
								<th>{{ $t("Username") }}</th>
								<th>{{ $t("Position") }}</th>
								<th>{{ $t("Status") }}</th>
							</tr>
							<tr>
								<td>2020.04.10<br />12:23:32</td>
								<td>TEST</td>
								<td>{{ $t("Left") }}</td>
								<td>{{ $t("Not approved") }}</td>
							</tr>
							<tr>
								<td>2020.04.10<br />12:23:32</td>
								<td>TEST1</td>
								<td>{{ $t("Right") }}</td>
								<td>{{ $t("Approved") }}</td>
							</tr>
							<tr>
								<td>2020.04.10<br />12:23:32</td>
								<td>TEST2</td>
								<td>{{ $t("Left") }}</td>
								<td>{{ $t("Not approved") }}</td>
							</tr>
							<tr>
								<td>2020.04.10<br />12:23:32</td>
								<td>TEST3</td>
								<td>{{ $t("Right") }}</td>
								<td>{{ $t("Approved") }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- /.contents -->

		<Footer title="Referral" />
	</div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
	name: "Referral",
	components: {
		Header,
		HeaderMenu,
		Sidebar,
		Footer,
	},
	data: () => {
		return {
			title: "Referral",
			code: "jfoweajfiojfafa",
			url: "https://www.OOO.com/jfoweajfioj…",
			isActive: "1",
		};
	},
	methods: {
		isSelect: function (num) {
			this.isActive = num;
		},
		codeCopy: function (e) {
			alert("You just copied: " + e.text);
		},
		codeError: function () {
			alert("Failed to copy texts");
		},
		urlCopy: function (e) {
			alert("You just copied: " + e.text);
		},
		urlError: function () {
			alert("Failed to copy texts");
		},
	},
	computed: {},
	mounted: function () {},
};
</script>
